/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { contract_terminations_InitiateTerminationRequest } from '../models/contract_terminations_InitiateTerminationRequest';
import type { contract_terminations_ProcessTerminationRequest } from '../models/contract_terminations_ProcessTerminationRequest';
import type { contract_terminations_ProcessTerminationResponse } from '../models/contract_terminations_ProcessTerminationResponse';
import type { contract_terminations_RevokePlanResponse } from '../models/contract_terminations_RevokePlanResponse';
import type { contract_terminations_RevokeTerminationRequest } from '../models/contract_terminations_RevokeTerminationRequest';
import type { contract_terminations_RevokeTerminationResponse } from '../models/contract_terminations_RevokeTerminationResponse';
import type { contract_terminations_TerminationPlanResponse } from '../models/contract_terminations_TerminationPlanResponse';
import type { models_WorkflowItem } from '../models/models_WorkflowItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractTerminationsService {
    /**
     * Revoke a contract termination
     * Revokes the termination (or the cancellation before start) of a contract group so the contract continues: cancels the selected invoices, removes the exit fees, reopens the contract with the recovered or the given end date, regenerates the invoices, restores the allocations where the slot is free and records the revoke on the termination workflow item. Returns 200 with per-step results; completed=false when a critical step failed. Idempotent: a repeated call completes an interrupted revoke.
     * @param id Contract group ID
     * @param request Revoke request
     * @returns contract_terminations_RevokeTerminationResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractGroupsRevoke(
        id: string,
        request: contract_terminations_RevokeTerminationRequest,
    ): CancelablePromise<contract_terminations_RevokeTerminationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contract-groups/{id}/revoke',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Authentication required or missing user context`,
                403: `Missing organisation context or module access`,
                404: `Not Found`,
                422: `Not revocable, invalid end date, or issued invoices not selected (code TERMINATION_REVOKE_*)`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Plan the revoke of a contract termination
     * Read-only plan for revoking the termination (or the cancellation before start) of a contract group: eligibility, the versions to reopen with their recovered pre-termination end, the invoices to cancel and regenerate, the exit fees to delete, the allocations to restore or skip, and the departure handover. Accepts `?new_end_date=` to recompute the allocation clamp for a different end.
     * @param id Contract group ID
     * @param newEndDate New contract end (YYYY-MM-DD)
     * @returns contract_terminations_RevokePlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractGroupsRevokePlan(
        id: string,
        newEndDate?: string,
    ): CancelablePromise<contract_terminations_RevokePlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contract-groups/{id}/revoke-plan',
            path: {
                'id': id,
            },
            query: {
                'new_end_date': newEndDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Authentication required`,
                403: `Missing organisation context or module access`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Initiate a contract termination / cancellation
     * Creates a contract_termination workflow item. Channel-agnostic (web_admin, email, parent_app). Exactly one of contract_id / contract_group_id is required.
     * @param request Termination intake
     * @returns models_WorkflowItem Created
     * @throws ApiError
     */
    public static postApiV1ContractTerminations(
        request: contract_terminations_InitiateTerminationRequest,
    ): CancelablePromise<models_WorkflowItem> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contract-terminations',
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Dry-run plan for a contract termination
     * Read-only consolidated plan (affected invoices, pending extras, settling-in, exit fees, allocations) for the Review & Confirm screen.
     * @param id Workflow item ID
     * @param effectiveEndDate Override end date (YYYY-MM-DD)
     * @returns contract_terminations_TerminationPlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractTerminationsPlan(
        id: string,
        effectiveEndDate?: string,
    ): CancelablePromise<contract_terminations_TerminationPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contract-terminations/{id}/plan',
            path: {
                'id': id,
            },
            query: {
                'effective_end_date': effectiveEndDate,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Execute the contract-termination saga
     * Runs the ordered, idempotent saga (fees → cancel invoices → terminate → re-issue → allocations). Returns 200 with per-step results; a failed critical step leaves the item approved (completed=false). The item must be in the approved state (409 otherwise).
     * @param id Workflow item ID
     * @param request Process request
     * @returns contract_terminations_ProcessTerminationResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractTerminationsProcess(
        id: string,
        request: contract_terminations_ProcessTerminationRequest,
    ): CancelablePromise<contract_terminations_ProcessTerminationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contract-terminations/{id}/process',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
}
